import React, { useContext } from "react";
import { Col, Row } from "antd";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import styles from "src/styles";

// Contexts
import { OffsetLayoutContext } from "src/contexts/layout.context";

// Helpers
import { calculateLayout } from "src/helpers/ui.helper";

// Assets
import backgroundImage from "src/assets/images/home_background.png";

const HomeBanner = () => {
    const offsetLayout = useContext(OffsetLayoutContext);
    const layout = calculateLayout(offsetLayout, 24);

    return (
        <DivStyled className="home-banner" backgroundImg={backgroundImage}>
            <Row className="image-container">
                <Col xs={24} lg={0} className="images">
                    <img src={backgroundImage} alt="background" />
                </Col>
                <Col xs={24} lg={0} className="mobile-content">
                    <Row>
                        <Col {...layout}>
                            <div className="body">
                                <div className="sub-title">
                                    <FormattedMessage id="homeBanner.content1" />
                                </div>
                                <div className="description">
                                    <FormattedMessage id="homeBanner.content2" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="content">
                <Col {...layout}>
                    <Row>
                        <Col xs={0} lg={{ offset: 14, span: 10 }}>
                            <div className="body">
                                <div className="sub-title">
                                    <FormattedMessage id="homeBanner.content1" />
                                </div>
                                <div className="description">
                                    <FormattedMessage id="homeBanner.content2" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </DivStyled>
    );
};

const DivStyled = styled.div<
    React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    > & { backgroundImg: string }
>`
    &.home-banner {
        background: url(${(props) => props.backgroundImg});
        background-repeat: no-repeat;
        height: 600px;

        @media screen and (max-width: 991px) {
            background: #112a50;
            height: unset;
        }

        .image-container {
            position: relative;
        }

        .mobile-content {
            position: absolute;
            bottom: 0;
            width: 100%;
            padding-bottom: 20px;
            color: ${styles.fontColorWhite};
            font-style: normal;
            font-weight: 400;
            line-height: 1.5;
            background: linear-gradient(
                0deg,
                #011a40 35%,
                rgba(1, 17, 64, 0) 100%
            );

            @media screen and (min-width: 576px) {
                padding-bottom: 48px;
            }
            @media screen and (min-width: 768px) {
                padding-bottom: 80px;
            }

            .body {
                margin-top: 13px;

                .sub-title {
                    font-weight: 500;
                    line-height: 1.3;
                    font-size: 40px;

                    @media screen and (max-width: 1199px) {
                        font-size: 30px;
                    }
                }

                .description {
                    margin-top: 9px;
                    font-size: 20px;

                    @media screen and (max-width: 1199px) {
                        font-size: 16px;
                    }
                }
            }
        }

        .content {
            display: flex;
            align-items: center;
            background: linear-gradient(
                270deg,
                #011a40 40%,
                rgba(1, 17, 64, 0) 75%
            );
            height: 100%;
            color: ${styles.fontColorWhite};
            font-style: normal;
            font-weight: 400;
            line-height: 1.5;

            .body {
                margin-top: 13px;

                .sub-title {
                    font-weight: 500;
                    line-height: 1.3;
                    font-size: 40px;

                    @media screen and (max-width: 1199px) {
                        font-size: 30px;
                    }
                }

                .description {
                    margin-top: 9px;
                    font-size: 20px;

                    @media screen and (max-width: 1199px) {
                        font-size: 16px;
                    }
                }
            }
        }

        .images {
            img {
                width: 100%;
                -webkit-mask-image: linear-gradient(
                    0deg,
                    #011a40 55%,
                    rgba(1, 17, 64, 0) 100%
                );
            }
        }
    }
`;

export default HomeBanner;
